import { DisplayItem } from 'design-system';

/**
 * Unified source for the money type options
 */
export const moneyTypes: DisplayItem[] = [
  { Value: 'CRC', Text: 'Colones' },
  { Value: 'USD', Text: 'Dólares' },
];

/**
 * Unified source for the money origin options
 */
export const moneyOrigins: DisplayItem[] = [
  { Value: '001', Text: 'Asalariado' },
  { Value: '002', Text: 'Pensionado' },
  { Value: '003', Text: 'Ingresos de negocio propio con razón social' },
  {
    Value: '004',
    Text: 'Actividad lucrativa desarrollada a título personal',
  },
  { Value: '005', Text: 'Ingresos aportados por terceras personas' },
  { Value: '006', Text: 'Ingresos extraordinarios' },
  { Value: '007', Text: 'Otras pensiones' },
];

export const moneyOriginsLegalPerson: DisplayItem[] = [
  { Value: '001', Text: 'Actividad económica' },
  { Value: '002', Text: 'Ingresos Extraordinarios' },
  { Value: '003', Text: 'Patrimonial' },
  { Value: '004', Text: 'Donación' },
  { Value: '005', Text: 'Otros' },
];

/**
 * Unified source for the stock origin options
 */
export const stockOrigins: DisplayItem[] = [
  { Value: 'EMGOV', Text: 'Empresa de Gobierno' },
  { Value: 'EMIOS', Text: 'Empresa de IOSCO' },
  { Value: 'NATPJ', Text: 'No aplica por tipo de persona jurídica' },
  { Value: 'NASRA14', Text: 'No aplica sociedad regulada por artículo 14' },
];

export default moneyOrigins;
